import { Command } from 'cmdk'
import cx from 'src/utils/cx'

const CmdKGroup = ({ children, ...props }) => {
  return (
    <Command.Group
      className={cx(
        '[&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:text-gray-500',
        'first:mt-1 [&+&]:mt-0.5',
        props.className
      )}
      {...props}
    >
      {children}
    </Command.Group>
  )
}

export default CmdKGroup
